import {FormattedMessage} from 'react-intl'
import {AsideMenuItem} from '../AsideMenuItem'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'

const FulfillmentMenu = () => {
  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()
  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.FULFILMENT_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-gray-300 fw-bold text-uppercase fs-8 ls-1'>
                <FormattedMessage id='GENERAL.ASIDE_MENU.FULFILMENT_SECTION' />
              </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) => (
            <AsideMenuItem
              key={index}
              to={item.to}
              title={item.title}
              fontIcon={item.fontIcon}
              icon={item.icon}
            />
          ))}
        </>
      )}
    </>
  )
}

const menuItems = [
  {
    to: '/fulfillment/accept',
    title: 'GENERAL.ASIDE_MENU.FULFILMENT_ACCEPT_TITLE',
    fontIcon: 'bi-sticky',
    icon: '/media/icons/duotune/coding/cod004.svg',
  },
  {
    to: '/fulfillment/unpack',
    title: 'GENERAL.ASIDE_MENU.FULFILMENT_UNPACK_TITLE',
    fontIcon: 'bi-sticky',
    icon: '/media/icons/duotune/coding/cod004.svg',
  },
  {
    to: '/fulfillment/goods',
    title: 'GENERAL.ASIDE_MENU.FULFILMENT_GOODS_TITLE',
    fontIcon: 'bi-sticky',
    icon: '/media/icons/duotune/ecommerce/ecm005.svg',
  },
]

export default FulfillmentMenu
